import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';
import { parseDurationToMinutes } from '../../utils/duration';

export const workflowStepsEndpoint = (id) =>
  `/api/v1/complaint-types/${id}/workflow-steps`;

function apiErrorMessage(error) {
  const data = error?.response?.data ?? error?.payload ?? error;
  const details = Array.isArray(data?.errors)
    ? data.errors.map((item) => item?.message).filter(Boolean)
    : [];
  if (details.length) return details.join(' ');
  return (
    data?.message ??
    data?.error ??
    error?.message ??
    'Something went wrong'
  );
}

function toBooleanFlag(value) {
  if (value === true || value === 'Yes' || value === 'yes' || value === 'true' || value === 1 || value === '1') {
    return true;
  }
  return false;
}

const rejectRequest = (error, thunkApi) =>
  thunkApi.rejectWithValue({
    status: error?.response?.status ?? error?.status,
    message: apiErrorMessage(error),
  });

export const fetchWorkflowSteps = createAsyncThunk(
  'workflow/fetchSteps',
  async (id, thunkApi) => {
    try {
      const response = await api.get(workflowStepsEndpoint(id));
      return response.data;
    } catch (error) {
      return rejectRequest(error, thunkApi);
    }
  },
);

export const updateWorkflowSteps = createAsyncThunk(
  'workflow/updateSteps',
  async ({ id, tables, onSuccess, onFail }, thunkApi) => {

    try {
      if (!Array.isArray(tables.tables)) {
        throw new Error('tables must be an array');
      }

      const steps = tables.tables.map((item, index) => ({
        levelNo: index + 1,
        roleIds: Array.isArray(item.role)
          ? item.role.map((roleId) => Number(roleId))
          : [],
        escalateAfterMinutes: parseDurationToMinutes(item.escalateAfterMinutes),
        canResolve: toBooleanFlag(item.canResolve),
        canReassign: toBooleanFlag(item.canReassign),
        isFinalLevel: toBooleanFlag(item.finalLevel),
        isActive: true,
      }));

      const response = await api.put(
        workflowStepsEndpoint(id),
        {
          
          steps,
        }
      );

      if (typeof onSuccess === 'function') {
        onSuccess(response.data);
      }

      return response.data;

    } catch (error) {
      if (typeof onFail === 'function') {
        onFail(error);
      }

      return rejectRequest(error, thunkApi);
    }
  }
);
